export const Types = {
    SPOUSE: "Spouse",
    CHILD: "Child"
}